import type { AppImage } from './appAssets'

/**
 * Approved brand assets. Use these exact files. Never retype, redraw or
 * regenerate the wordmark, and never crop its lettering or bolt.
 */
export const brandWordmark: AppImage = {
  src: 'https://cdn.magicpatterns.com/uploads/fca6gvcsLbW2Et15uLjUnS/lightning-learn-approved-wordmark.png',
  alt: 'Lightning Learn',
  width: 1536,
  height: 1024,
}

export const foxCutout: AppImage = {
  src: 'https://cdn.magicpatterns.com/uploads/aw2YYXCU6reyh2eZKqaiQz/fox-transparent-v1.png',
  alt: 'Orange fox explorer with a teal shoulder bag',
  width: 1024,
  height: 1024,
}

export const foxAppIcon: AppImage = {
  src: 'https://cdn.magicpatterns.com/uploads/84r4NgA9PdsXqGT3fKvGUH/fox-icon-lavender.png',
  alt: 'Lightning Learn app icon: an orange fox on lavender',
  width: 1024,
  height: 1024,
}

/** Real Dinosaur Days lesson shown in the hero phones. */
export const dinoLesson = {
  world: 'Dinosaur Days',
  title: 'How Do Scientists Know What Dinosaurs Ate?',
  cover: {
    src: 'https://cdn.magicpatterns.com/uploads/mmWtgDWxgKVnjM2gQzSLjn/DD-04-dinosaur-diets.png',
    alt: 'Illustrated cover for the Dinosaur Days adventure about how scientists know what dinosaurs ate',
    width: 1024,
    height: 1024,
  } satisfies AppImage,
  badge: {
    name: 'Dino Tooth Tracker',
    src: 'https://cdn.magicpatterns.com/uploads/4agmUcPM6nzbvbZtEZvTMK/DD-04-embroidered-patch-v1.webp',
    alt: 'Dino Tooth Tracker embroidered patch with a dinosaur skull and magnifying glass examining its teeth.',
    width: 1024,
    height: 1024,
  } satisfies AppImage & { name: string },
}
